import { Container } from "@/providers/error-boundary/styles";
import { useNavigate } from "react-router-dom";
import { Button } from "tvs-unified-lib";
import { ButtonContainer, Message, NotFoundIcon, Title } from "./styles";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container>
      <NotFoundIcon>
        <div>0</div>
      </NotFoundIcon>
      <Title>Page Not Found</Title>
      <Message>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </Message>
      <ButtonContainer>
        {/* TODO: do not use navigate(-1) because it will cause infinite loop */}
        {/* <Button
          onClick={() => navigate(-1)}
          theme="purple"
          variant="outline"
          label="Go Back"
        /> */}
        <Button
          onClick={() => navigate("/")}
          theme="purple"
          variant="block"
          label="Go to Home"
        />
      </ButtonContainer>
    </Container>
  );
}
